import type VueRouter from 'vue-router'

import { type LoginAttemptResult, authExternal } from '@/helpers/AuthExternal'
import { withSellerPrefix } from '@/helpers/route'

import { API } from '@/api/API'
import store from '@/store/store'

export async function logout(router?: VueRouter, nextPath?: string): Promise<LoginAttemptResult | void> {
  if (authExternal.isExternalAuth()) {
    // Don't prepend seller prefix when using current URL, pathname includes seller slug
    return authExternal.logout(
      nextPath ? withSellerPrefix(nextPath) : window.location.pathname + window.location.search,
    )
  }

  await API.post('logout')
  await store.dispatch('clearAll')

  if (router && nextPath) router.push(nextPath)
}

export function ensureLoggedOut(): Promise<LoginAttemptResult | void> {
  return isLoggedIn() ? logout() : Promise.resolve()
}

export function isLoggedIn(): boolean {
  return Boolean(store.getters['Member/user'])
}
